<script setup>

const props = defineProps({
  show: Boolean,
  userName: String,
  regDate: String,
  totalSpend: Number
})

const emit = defineEmits([
  'switchUser',
  'logout'
])

const switchUserHandler = () => {
  emit('switchUser');
}

const logoutHandler = () => {
  emit('logout');
}

</script>

<template>
  <Transition name="slide-fade">
    <div v-if="props.show" class="user-info-card">
      <div class="info-header">
        <div class="big-avatar">SY</div>
        <div class="header-meta">
          <h3>{{ props.userName }}</h3>
          <p>管理者アカウント</p>
        </div>
      </div>
      <div class="info-body">
        <div class="data-row"><span>登録日</span><strong>{{ props.regDate }}</strong></div>
        <div class="data-row"><span>累計費用</span><strong>{{ "¥" + props.totalSpend }}</strong></div>
      </div>
      <div class="info-footer">
        <button class="action-btn switch" @click="switchUserHandler">ユーザー切り替え</button>
        <button class="action-btn logout" @click="logoutHandler">ログアウト</button>
      </div>
    </div>
  </Transition>
</template>

<style scoped>

.user-info-card {
  position: absolute;
  top: 75px;
  right: 30px;
  width: 320px;

  /* 浅色卡片 */
  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);
  color: #0f172a;

  border: 1px solid rgba(30, 64, 175, 0.25);
  padding: 26px;
  z-index: 5000;

  box-shadow:
      0 25px 60px rgba(0, 0, 0, 0.25),
      inset 0 0 0 rgba(255,255,255,0);

  backdrop-filter: blur(6px);
  clip-path: polygon(
      0 0,
      100% 0,
      100% calc(100% - 14px),
      calc(100% - 14px) 100%,
      0 100%
  );
}

.user-info-card h3 {
  color: #0f172a;
}

.user-info-card p {
  color: #2563eb;
}

.user-info-card .data-row span {
  color: #475569;
}

.user-info-card .data-row strong {
  color: #0f172a;
}

.user-info-card .action-btn {
  background: #e0e7ff;
  border: 1px solid #c7d2fe;
  color: #1e3a8a;
}

.user-info-card .action-btn:hover {
  background: #2563eb;
  color: #ffffff;
  box-shadow: 0 0 12px rgba(37, 99, 235, 0.45);
}

.user-info-card .action-btn.logout {
  background: #fee2e2;
  border-color: #fecaca;
  color: #991b1b;
}


.info-header {
  display: flex;
  gap: 18px;
  align-items: center;
  margin-bottom: 20px;
  border-bottom: 1px solid rgba(0, 102, 255, 0.2);
  padding-bottom: 15px;
}

.big-avatar {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #0040FF, #00D1FF);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 800;
  box-shadow: 0 0 15px rgba(0, 162, 255, 0.4);
}

.header-meta h3 {
  font-size: 18px;
  margin: 0;
  color: #808d2d;
  letter-spacing: 1px;
}

.header-meta p {
  font-size: 11px;
  color: #00D1FF;
  margin: 4px 0 0;
  font-weight: bold;
  text-transform: uppercase;
}

.action-btn {
  width: 100%;
  padding: 12px;
  background: rgba(0, 64, 255, 0.1);
  border: 1px solid rgba(0, 102, 255, 0.3);
  color: #fff;
  cursor: pointer;
  margin-top: 10px;
  font-size: 12px;
  font-weight: bold;
  transition: 0.3s;
  clip-path: polygon(5% 0, 100% 0, 95% 100%, 0 100%);
}

.action-btn:hover {
  background: #0040FF;
  box-shadow: 0 0 15px #0040FF;
}

.action-btn.logout {
  color: #ff4d4d;
  border-color: rgba(255, 0, 0, 0.15);
}

.data-row {
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px dashed rgba(255, 255, 255, 0.05);
  font-size: 13px;
}

.data-row span {
  color: #64748B;
}

.data-row strong {
  color: #E2E8F0;
  font-family: 'Courier New', monospace;
}
</style>
